import { RootState } from '..'
import { IStateNetwork } from './type'

export const selectNetwork = (state: RootState): IStateNetwork => state.networks
